import React, { Component } from "react";
import "./home.css";
// import SliderComp from "../../components/slider";
// import Nosotros from "../nosotros/";
import scrollToComponent from "react-scroll-to-component";
import { Image, Button } from "react-bootstrap";

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widthTriangle: 0
    };
  }
  componentWillMount() {}
  changeWidthTriangle() {
    if (this.refs.nosotros !== undefined)
      this.setState({ widthTriangle: this.refs.nosotros.offsetWidth });
  }
  render() {
    return (
      <div className="navMargin" style={{ height: "100%" }}>
        <section
          style={{
            backgroundColor: "#e9e9e9",
            alignContent: "center",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            height: "100%"
          }}
        >
          <Image
            src={require("../../img/logoLanding.png")}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            responsive
          />
          <p
            style={{
              textAlign: "center",
              fontSize: "45pt",
              color: "#27a7a5",
              fontStyle: "italic"
            }}
          >
            “Asesoría y Consultoría <br /> para investigadores académicos”
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button bsStyle="primary" bsSize="large" bsClass="btn rouded">
              ¡Me Interesa!
            </Button>
          </div>
        </section>
        {/* <section style={{backgroundColor:"#d0fde2"}}>
          <SliderComp/>
        </section>
        <section style={{
          marginTop:25,
          width: 0,
          height: 0,
          backgroundColor: 'transparent',
          borderStyle: 'solid',
          borderTopWidth: 70,
          borderRightWidth: this.state.widthTriangle,
          borderBottomWidth: 0,
          borderLeftWidth: 0,
          borderTopColor: '#d0fde2',
          borderRightColor: 'transparent',
          borderBottomColor: 'transparent',
          borderLeftColor: 'transparent',
        }}></section>
        <section ref="nosotros">
          <Nosotros/>
        </section>
        <section style={{
          marginTop:25,
          width: 0,
          height: 0,
          backgroundColor: 'transparent',
          borderStyle: 'solid',
          borderTopWidth: 70,
          borderRightWidth: this.state.widthTriangle,
          borderBottomWidth: 0,
          borderLeftWidth: 0,
          borderTopColor: 'transparent',
          borderRightColor: '#d0fde2',
          borderBottomColor: 'transparent',
          borderLeftColor: 'transparent',
        }}></section>
        <section ref="footer" style={{backgroundColor:"#d0fde2"}}>
        <div className="container" style={{paddingTop:10}}>
          <p>
          El uso continuo de los servicios constituye por sí solo, la aceptación de estos términos.
Los precios están expresados en pesos mexicanos y están sujetos a cambio sin previo aviso. 
No se aceptan devoluciones.
<br/>
Editorial T&R S.A. de C.V. podrá suspender, diferir o denegar la prestación de los servicios, en tanto el usuario no cumpla con los presentes términos.
Todos los materiales presentados en este sitio web son propiedad intelectual de Editorial T&R S.A. de C.V. y se prohibe la copia o reproducción, por cualquier medio, no autorizada de cualquiera de ellos. Los comentarios y opiniones vertidas por los autores y colaboradores de Editorial T&R son responsabilidad de quien los hace , y no necesariamente coinciden con los puntos de vista de la editorial. Se incluyen en la página como ejercicio del derecho de la libre expresión.
La publicación, distribución, asignación, venta, alteración o reproducción de los contenidos de las publicaciones, en forma total o parcial queda expresamente prohibido al usuario, sin el permiso por escrito de los autores.
Este convenio estará sujeto y será interpretado de acuerdo con las leyes y ante los tribunales del estado de Nuevo León, México.
Cualquier duda con relación a este sitio Web se atenderá en el correo electrónico editorialtyr@gmail.com
          </p>
          </div>
        </section> */}
      </div>
    );
  }
  componentWillUpdate() {
    var self = this;
    if (window.location.href.indexOf("nosotros") > -1) {
      setTimeout(() => {
        scrollToComponent(self.refs["nosotros"], {
          offset: -70,
          align: "top",
          duration: 500
        });
      }, 500);
    }
  }
  componentDidMount() {
    // keep one bound reference so componentWillUnmount removes the same listener
    this.onResize = this.changeWidthTriangle.bind(this);
    this.changeWidthTriangle();
    window.addEventListener("resize", this.onResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }
}



// WEBPACK FOOTER //
// ./src/views/home/index.js